import React, {PureComponent} from 'react'

class ImgLoader extends PureComponent{
  state={
    open: false
  }

  componentDidMount(){
    this.changeImgSrc()
  }

  changeImgSrc(){
   const that = this
    const images = document.getElementsByClassName(this.props.className)[0]
    console.log(this.props.className)
    const large =document.createElement('img')
    // console.log('loadinnnnnnnnnn', this.props.src)
    large.onload=function (){
      images.src=this.src
    }
    // console.log('images----->>', images)
    setTimeout(function(){
      // console.log('2222', that.props.src)
      large.src = that.props.src
    },500)


  }


  render(){
    const {className}=this.props
    return(
      <img className={className} src={require('../static/loading.gif')} alt="..."/>
    )
  }
}

export {ImgLoader}